import { GET_HOTEL, SET_LOADING_HOTEL, SET_PAGINATION_HOTEL } from '../constant';

const initialState = {
  hotel: [],
  loadingHotel: false,
  hotelPagination: 0,
  totalHotel: 0,
};

const hotelReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_HOTEL: {
      return {
        ...state,
        loadingHotel: action?.payload,
      };
    }
    case SET_PAGINATION_HOTEL: {
      return {
        ...state,
        hotelPagination: action?.payload,
      };
    }
    case GET_HOTEL: {
      return {
        ...state,
        hotel: action?.payload?.data || [],
        totalHotel: action?.payload?.total,
        loadingHotel: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default hotelReducer;
